/**
 * Formation Package — static option lists (authorities, license types,
 * legal forms, facility types, etc.). Isolated from the form so they can
 * be reused by future pages (browser card / quote generator).
 */

export const AUTHORITIES = [
  { slug: 'rakez',       ar: 'راكز — رأس الخيمة',       en: 'RAKEZ — Ras Al Khaimah' },
  { slug: 'ifza',        ar: 'IFZA — دبي',              en: 'IFZA — Dubai' },
  { slug: 'meydan',      ar: 'ميدان الحرة — دبي',       en: 'Meydan Free Zone — Dubai' },
  { slug: 'det_dubai',   ar: 'دائرة الاقتصاد — دبي',    en: 'DET Dubai (mainland)' },
  { slug: 'added',       ar: 'ADDED — أبوظبي',          en: 'ADDED — Abu Dhabi' },
  { slug: 'adgm',        ar: 'ADGM — أبوظبي',           en: 'ADGM — Abu Dhabi' },
  { slug: 'difc',        ar: 'DIFC — دبي',              en: 'DIFC — Dubai' },
  { slug: 'dmcc',        ar: 'DMCC — دبي',              en: 'DMCC — Dubai' },
  { slug: 'jafza',       ar: 'JAFZA — جبل علي',         en: 'JAFZA — Jebel Ali' },
  { slug: 'dafza',       ar: 'DAFZA — دبي',             en: 'DAFZA — Dubai' },
  { slug: 'sharjah_spc', ar: 'SPC Free Zone — الشارقة', en: 'SPC Free Zone — Sharjah' },
  { slug: 'ajman_fz',    ar: 'عجمان الحرة',              en: 'Ajman Free Zone' },
];

export const LICENSE_TYPES = [
  { key: 'commercial',      ar: 'تجارية',         en: 'Commercial' },
  { key: 'services',        ar: 'خدمات',          en: 'Services' },
  { key: 'media',           ar: 'إعلامية',        en: 'Media' },
  { key: 'ecommerce',       ar: 'تجارة إلكترونية', en: 'E-commerce' },
  { key: 'general_trading', ar: 'تجارة عامة',      en: 'General Trading' },
  { key: 'education',       ar: 'تعليمية',         en: 'Education' },
  { key: 'consulting',      ar: 'استشارية',        en: 'Consulting' },
  { key: 'industrial',      ar: 'صناعية',          en: 'Industrial' },
  { key: 'tourism',         ar: 'سياحية',          en: 'Tourism' },
];

export const LEGAL_FORMS = [
  { key: 'fz_llc',                 ar: 'FZ-LLC',                 en: 'FZ-LLC' },
  { key: 'llc',                    ar: 'ذ.م.م',                  en: 'LLC' },
  { key: 'subsidiary',             ar: 'شركة تابعة',              en: 'Subsidiary' },
  { key: 'branch_local',           ar: 'فرع شركة محلية',           en: 'Branch of Local Company' },
  { key: 'branch_foreign',         ar: 'فرع شركة أجنبية',          en: 'Branch of Foreign Company' },
  { key: 'sole_establishment',     ar: 'مؤسسة فردية',              en: 'Sole Establishment' },
  { key: 'civil_company',          ar: 'شركة مدنية',               en: 'Civil Company' },
];

export const FACILITY_TYPES = [
  { key: 'coworking',      ar: 'مساحة عمل مشتركة', en: 'Coworking Space' },
  { key: 'dedicated_desk', ar: 'مكتب مخصص',        en: 'Dedicated Desk' },
  { key: 'private_office', ar: 'مكتب خاص',         en: 'Private Office' },
  { key: 'virtual_flexi',  ar: 'مكتب افتراضي',     en: 'Virtual / Flexi Desk' },
];

export const ADVISORY_TOPICS = [
  { key: 'ai_adoption', ar: 'تبني الذكاء الاصطناعي', en: 'AI adoption' },
  { key: 'ecommerce',   ar: 'التجارة الإلكترونية',    en: 'E-commerce' },
  { key: 'growth',      ar: 'النمو والتوسع',          en: 'Growth' },
  { key: 'compliance',  ar: 'الامتثال والحوكمة',      en: 'Compliance' },
  { key: 'tax',         ar: 'الضرائب',                en: 'Tax' },
];

export const PARTNER_BANKS = ['ADCB', 'ENBD', 'RAKBANK', 'CBD', 'EIB', 'ADIB', 'FAB'];
